import classNames from 'classnames';
import { forwardRef } from 'react';
import { Layout } from 'components/layout';
import { UserInfoAvatar } from 'features/user_profiles';
const ListItemActions = props => <Layout align="center" gap="8" {...props} />;
const listWrapperHasErrorCss = "l1b1vtmf";
const listWrapperIsLockedCss = "le15hmh";
const listWrapperCss = "l190dloa";
const ListWrapper = forwardRef((props, ref) => {
  const {
    hasError,
    isLocked,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(listWrapperCss, {
    [listWrapperHasErrorCss]: hasError,
    [listWrapperIsLockedCss]: isLocked
  }, props.className)} />;
});
const styledUserInfoAvatarSpacelessCss = "sxn4rzo";
const styledUserInfoAvatarCss = "s13vlp9h";
const StyledUserInfoAvatar = forwardRef((props, ref) => {
  const {
    spaceless
  } = props;
  return <UserInfoAvatar ref={ref} {...props} className={classNames(styledUserInfoAvatarCss, {
    [styledUserInfoAvatarSpacelessCss]: spaceless
  }, props.className)} />;
});
export { ListWrapper, ListItemActions, StyledUserInfoAvatar };

require("./styles.wyw-in-js.css!=!../../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");